import { defineComponent as _defineComponent } from 'vue';
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { faArrowLeft, faEdit, faHdd, faSitemap } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BButtonGroup } from "bootstrap-vue";
import { useWorkflowInstance } from "@/composables/useWorkflowInstance";
import localize from "@/utils/localization";
import Heading from "../Common/Heading.vue";
import SwitchToHistoryLink from "../History/SwitchToHistoryLink.vue";
import UtcDate from "../UtcDate.vue";
import WorkflowInvocationsCount from "../Workflow/WorkflowInvocationsCount.vue";
import WorkflowRunButton from "../Workflow/WorkflowRunButton.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowInvocationHeader',
    props: {
        invocation: null,
        fromPanel: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const { workflow } = useWorkflowInstance(props.invocation.workflow_id);
        function getWorkflowName() {
            var _a;
            return ((_a = workflow.value) === null || _a === void 0 ? void 0 : _a.name) || "...";
        }
        return { __sfc: true, props, workflow, getWorkflowName, faClock, faArrowLeft, faEdit, faHdd, faSitemap, FontAwesomeIcon, BButton, BButtonGroup, localize, Heading, SwitchToHistoryLink, UtcDate, WorkflowInvocationsCount, WorkflowRunButton };
    }
});
